<script lang="ts" setup></script>

<template>
  <svg
    id="Zakladniprvky_Lupa"
    xmlns="http://www.w3.org/2000/svg"
    width="14.105"
    height="14.105"
    viewBox="0 0 14.105 14.105"
  >
    <g
      id="Ellipse_35"
      data-name="Ellipse 35"
      fill="none"
      stroke="#000"
      stroke-width="1"
    >
      <circle cx="6" cy="6" r="6" stroke="none" />
      <circle cx="6" cy="6" r="5.5" fill="none" />
    </g>
    <path
      id="Path_682"
      data-name="Path 682"
      d="M23820.021-112.5h5.6"
      transform="translate(-16913.057 -16753.959) rotate(45)"
      fill="none"
      stroke="#000"
      stroke-width="1"
    />
  </svg>
</template>
